import IndustrialChemicals from "./IndustrialChemicals.jsx";
export default IndustrialChemicals